import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../../components/ui/Button';
import { Input } from '../../components/ui/Input';
import { registerWithWebAuthn, isWebAuthnSupported } from '../../lib/webauthn';

export function RegisterPage() {
  const [username, setUsername] = useState('');
  const [displayName, setDisplayName] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleRegister = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    setError(null);

    if (!isWebAuthnSupported()) {
      setError('WebAuthn is not supported in this browser');
      setIsLoading(false);
      return;
    }

    try {
      await registerWithWebAuthn(username, displayName);
      // User is now logged in - session token and user info are stored in localStorage
      // Force a page reload to refresh AuthContext
      window.location.href = '/';
    } catch (err: any) {
      setError(err.message || 'Registration failed. Please try again.');
      console.error('Registration error:', err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="bg-white dark:bg-slate-900 p-8 rounded-lg border border-slate-300 dark:border-slate-800">
      <h2 className="text-2xl font-bold text-slate-900 dark:text-slate-100 mb-6">Register with WebAuthn</h2>

      {error && (
        <div className="mb-4 p-3 bg-red-100 dark:bg-red-900/50 border border-red-400 dark:border-red-700 rounded-lg text-red-800 dark:text-red-200 text-sm">
          {error}
        </div>
      )}

      <form onSubmit={handleRegister} className="space-y-4">
        <Input
          label="Username"
          type="text"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          placeholder="Choose a username"
          required
        />

        <Input
          label="Display Name"
          type="text"
          value={displayName}
          onChange={(e) => setDisplayName(e.target.value)}
          placeholder="Your display name"
          required
        />

        <Button type="submit" className="w-full" isLoading={isLoading}>
          Register Device
        </Button>
      </form>

      <p className="mt-4 text-center text-slate-500 dark:text-slate-400 text-sm">
        Already have an account?{' '}
        <Link to="/login" className="text-brand-600 dark:text-brand-400 hover:text-brand-700 dark:hover:text-brand-500">
          Login
        </Link>
      </p>
    </div>
  );
}
